@if (!item) {
  <div class="empty-state">
    @if (section() === 'notebooks') {
      <app-no-content-stub imageSrc="assets/placeholders/placeholder-notes.svg" [size]="124">
        <p class="text-base font-medium text-gray-900 text-center">No notebook selected</p>
        <app-button2 class="[&>button]:bg-offwhite" appearance="secondary" size="m" [gap]="4" (click)="handleNewNotebook()">
          <app-icon name="notebook-lines" />
          Create a new notebook
        </app-button2>
      </app-no-content-stub>
    } @else {
      <app-no-content-stub imageSrc="assets/placeholders/placeholder-notes.svg" [size]="124">
        <p class="text-base font-medium text-gray-900 text-center">No note selected</p>
        <app-button2 class="[&>button]:bg-offwhite" appearance="secondary" size="m" [gap]="4" (click)="handleNewNote()">
          <app-icon name="notes" />
          Write a new note
        </app-button2>
      </app-no-content-stub>
    }
  </div>
}

@if (item) {
  @switch (item | stitchType) {
    @case (StitchType.NOTE) {
      <app-note-form
        id="note-form"
        [note]="asNote(item)"
        (close)="handleFormClose($event)"
        />
    }
    @case (StitchType.NOTEBOOK) {
      <app-notebook-form
        id="notebook-form"
        [notebook]="asNotebook(item)"
        (close)="handleFormClose($event)"
        />
    }
  }
}
